import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = ({ fullWidth }) => {
  const navigate = useNavigate();
  
  const handleClickPolicy = () => {
    navigate("/policy");
    window.scrollTo(0, 0);
  };
  return (
    <footer>
  <div
    className={`${
      fullWidth
        ? "w-full"
        : "w-full lg:max-w-[75%]"
    }`}
  >
    <div className="bg-black text-gray-200 px-6 py-3">
      <div className="flex flex-col justify-center items-center">
        <p className="text-center">
          © 2023. All rights reserved.
          <span
            onClick={handleClickPolicy}
            className="text-[#f2c426] hover:underline mx-1 cursor-pointer"
          >
            Disclaimer & Privacy Policy
          </span>
        </p>
      </div>
    </div>
  </div>
</footer>

  );
};

export default Footer;
